import { render, staticRenderFns } from "./bo-label-filter.vue?vue&type=template&id=70f14458"
import script from "./bo-label-filter.vue?vue&type=script&lang=js"
export * from "./bo-label-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports